export const LR_SHIPMENT_ID_FORMAT = '{lrbranch}{ylet}{mlet}-{user}-{seq}';

export const isLrShipmentFormat = (fmt) =>
  String(fmt || '').trim().toLowerCase() === LR_SHIPMENT_ID_FORMAT;

/** Place Month letter in front of Number so a new month cannot reprint the same ID. */
export const ensureMonthLetter = (fmt) => {
  const text = String(fmt || '').trim();
  if (!text) return text;
  if (text.toLowerCase().includes('{mlet}') || isLrShipmentFormat(text)) return text;
  const match = text.match(/\{seq\}/i);
  if (!match) return `${text}-{mlet}`;
  const start = match.index;
  const sep = start > 0 && '-./_'.includes(text[start - 1]) ? text[start - 1] : '-';
  return `${text.slice(0, start)}{mlet}${sep}${text.slice(start)}`;
};
